export enum MenuType {
  "game" = "game",
  "bbs" = "bbs",
  "toolkit" = "toolkit",
  "top" = "top",
  "column" = "column",
  "none" = "none"
}
